import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import router from "./router";
import site from "./config/config.js"
import ElementUI from 'element-ui';
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/index.css"
import requests from './utils/axios.js'

Vue.use(Vuex)


// const store = new Vuex.Store({
// 	state: {
// 		gamelist: [],
// 		isMobile: false,
// 	},
// 	getters: {
// 		isMobile: state => state.isMobile,
// 	},
// 	mutations: {
// 		// 同步异步请求的数据
// 		setList(state, res) {
// 			state.gamelist = res;
// 		},
// 		SET_IS_MOBILE: (state, isMobile) => state.isMobile = isMobile,
// 	}
// })


Vue.prototype.rq = requests
Vue.prototype.img_url = "http://img.h6ds.com/"
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(site)

new Vue({
	router,
	store: store,
	render: (h) => h(App),
}).$mount("#app");
